module.exports = __webpack_public_path__ + "static/epitome-venti2-button-bea82fd1aec1071359ab6e01eb905b87.png";